<template>
    <el-dialog
            title="图片选择器"
            :visible.sync="dialogVisible"
            width="795px"
            :append-to-body="true"
            :modal-append-to-body="false"
            class="imageDialog" v-if='dialogVisible' :destroy-on-close="true" :close-on-click-modal="false">
        <div class="image-upload-content">
            <div class="category">
                <div class="category-box">
                    <Spin fix v-if="categoryLoading"></Spin>
                    <div class="category-item" @click="selectCategory('0')" :class="category_active == '0' || category_active == '' ? 'active' : ''">全部</div>

                    <div class="category-item" @click="selectCategory(category.id)" :class="category_active == category.id ? 'active' : ''" v-for="category in category_list">
                        <div class="category-name">{{category.name}}</div>
                        <div class="category-tooltip" v-if="category_active == category.id">
                            <el-popover
                                placement="top"
                                width="200"
                                v-model="editVisible" @hide="resetCategoryName" @show="showCategoryName(category.name)">
                                <div class="">
                                    <p style="font-size: 12px;">编辑分类</p>
                                    <div style="margin: 15px 20px;">
                                        <el-input placeholder="分类名称" size="small" v-model="category_name"></el-input>
                                    </div>
                                </div>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="text" @click="editVisible = false">取消</el-button>
                                    <el-button type="primary" size="mini" @click="setCategory('edit', category.id)" style="padding: 7px 8px;">确定</el-button>
                                </div>
                                <i class="el-icon-edit" slot="reference" style="margin-right:5px;color:#666"></i>
                            </el-popover>
                            <el-popover
                                    placement="right"
                                    width="160"
                                    v-model="deleteVisible">
                                <p style="font-size: 12px;margin-bottom:10px">确定删除该分类？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="text" @click="deleteVisible = false">取消</el-button>
                                    <el-button type="primary" size="mini" @click="deleteCategory(category.id)" style="padding: 5px 6px;font-size:12px;">确定</el-button>
                                </div>
                                <i class="el-icon-delete" slot="reference" style="color:#666"></i>
                            </el-popover>
                        </div>
                    </div>
                </div>
                <el-popover
                        placement="top"
                        width="200"
                        v-model="visible" @hide="resetCategoryName">
                    <div class="">
                        <p style="font-size: 12px;">添加分类</p>
                        <div style="margin: 15px 20px;">
                            <el-input placeholder="分类名称" size="small" v-model="category_name"></el-input>
                        </div>

                    </div>
                    <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="setCategory('add')" style="padding: 7px 8px;">确定</el-button>
                    </div>
                    <el-button size="small" style="width: 130px;margin-left: 2px;" slot="reference">+新建分类</el-button>
                </el-popover>
            </div>
            <div class="image-list">
                <div class="image-controller">
                    <el-input placeholder="搜索图片名称" v-model="keywords" class="image-search" size="small">
                        <i slot="append" class="el-icon-search" @click="searchImageList"></i>
                    </el-input>
                    <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            accept="image/bmp,image/png,image/jpeg,image/jpg,image/gif"
                            :show-file-list="false"
                            :multiple="true"
                            :data="{category_id: category_active, upload_type: 'image'}"
                            :on-success="(res)=>{ return dealUpload(res)}"
                            :on-progress="uploadLoading"
                            :before-upload="beforeUpload"
                            :with-credentials="true"
                            :limit="uploadLimit"
                            :on-exceed="uploadExceed"
                            list-type="picture" style="float: right">
                        <el-button size="small" type="primary" @click="uploadCount = 0">上传图片</el-button>
                    </el-upload>
                    <div class="upload-limit">
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content">图片大小不要超过10M,支持图片类型包括 gif,jpg,png<br>每次上传数量少于10张</div>
                            <i class="iconfont icon-yiwen" style="font-size: 18px;"></i>
                        </el-tooltip>

                    </div>
                </div>
                <div class="image-list-content">
                    <Spin fix v-if="listLoading"></Spin>
                    <div class="img-box" v-for="(imageInfo, index) in imageList">
                        <div @click="selectImage(index)" class="img" :class="selectImageIdArr.indexOf(imageInfo.id) >= 0 ? 'active' : ''" :style='"background-image: url(\"" + imageInfo.url + "\");"'></div>
                        <el-popover class="delete-popover" v-model="deleteImageVisible[index]"
                                    placement="left"
                                    width="160">
                            <p style="font-size: 12px;margin-bottom:10px">确定删除该图片？删除后将无法正常显示！</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="cancelDeleteImage(index)">取消</el-button>
                                <el-button type="primary" size="mini" @click="deleteImage(index, imageInfo.id)" style="padding: 5px 6px;font-size:12px;">确定</el-button>
                            </div>
                            <i slot="reference" class="img-delete el-icon-error"></i>
                        </el-popover>
                        <div class="img-info">{{imageInfo.text}}</div>
                        <div class="select-mask active" @click="cancelSelectImage(selectImageIdArr.indexOf(imageInfo.id))">
                            <i class="el-icon-check" style="font-size: 20px;"></i>
                            <div class="number" v-if="selectType == 'checkbox' && selectImageIdArr.indexOf(imageInfo.id) >= 0 ">{{selectImageIdArr.indexOf(imageInfo.id) + 1}}</div>
                        </div>
                        <div class="resource-name">{{imageInfo.name}}</div>
                    </div>
                </div>
                <div class="image-list-bottom">
                    <div class="choose-num" v-if="selectImageIdArr.length > 0">
                        已选择<span>{{selectImageIdArr.length}}</span>张
                        <el-button size="mini" style="margin-left: 10px;" @click="cancelSelectImage('all')">取消选择</el-button>
                    </div>
                    <Page style="float: right;font-size: 12px;" :current="current" :total="total" :page-size="pageSize" simple />
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="hideDialog">取消</el-button>
            <el-button size="mini" @click="btnClick">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "ChooseImage",
        data() {
            return {
                uploadUrl: window.settings.api_url + "utility/upload/upload",
                editVisible: false,
                deleteVisible: false,
                deleteImageVisible: [],
                visible: false,
                dialogVisible: false,
                keywords: '',
                category_name: '',
                category_list: [],
                category_active: '',
                categoryLoading: true,
                listLoading: true,
                pageSize: 15,
                total: 0,
                current: 1,
                imageList:[],
                uploadCount: 0,
                uploadLimit: 10,
                selectType: 'radio',
                selectImageList: [],
                selectImageIdArr:[],
                maxSelectCount: 9
            };
        },
        created() {
            const self = this;
            self.FoxRequest(window.settings.api_url + 'utility/upload/get_category', {

            }, function(response){
                let data = response.data;
                self.categoryLoading = false;
                if(data.error == '0'){
                    self.category_list = data.result
                }
            });
            self.reloadImageList();
        },
        methods: {
            hideDialog(){
                const self = this;
                self.dialogVisible = false;
            },
            btnClick () {
                const  self = this;
                this.dialogVisible = false;
                this.confirmBtn(self.selectImageList);

            },
            uploadLoading(event, file, fileList){
                this.uploadEnd = 0;
            },
            resetCategoryName(){
                this.category_name = ""
            },
            showCategoryName(category_name = ''){
                this.category_name = category_name;
            },
            selectCategory(category_id = '0'){
                const self = this;
                self.reloadImageList(category_id);
            },
            setCategory(type = 'add', category_id = '0'){
                const self = this;
                self.categoryLoading = true;
                self.FoxRequest(window.settings.api_url + 'utility/upload/set_category', {
                    type: type,
                    category_id: category_id,
                    category_name: self.category_name
                }, function(response){
                    let data = response.data;
                    self.categoryLoading = false;
                    if(data.error == '0'){
                        self.$message({
                            message: data.result.message,
                            type: 'success',
                            duration: 1500,
                            onClose: function () {
                            }
                        });
                        self.category_list = data.result.list;
                        if(type == 'add'){
                            self.visible = false;
                        }else{
                            self.editVisible = false;
                        }
                    }else{
                        self.$message({
                            message: data.result.message,
                            type: 'error',
                            duration: 1500,
                            onClose: function () {
                            }
                        });
                    }
                });
            },
            deleteCategory(category_id = '0'){
                const self = this;
                self.categoryLoading = true;
                self.FoxRequest(window.settings.api_url + 'utility/upload/delete_category', {
                    category_id: category_id
                }, function(response){
                    let data = response.data;
                    self.categoryLoading = false;
                    self.deleteVisible = false;
                    if(data.error == '0'){
                        self.$message({
                            message: data.result.message,
                            type: 'success',
                            duration: 1500,
                            onClose: function () {
                            }
                        });
                        self.category_list = data.result.list;
                        self.reloadImageList('0');
                    }else{
                        self.$message({
                            message: data.result.message,
                            type: 'error',
                            duration: 1500,
                            onClose: function () {
                            }
                        });
                    }
                });

            },
            reloadImageList(category_id = '0', refresh = false, resetKeywords = false){
                const self = this;
                if(self.category_active == category_id && refresh == false){
                    return false;
                }
                if(resetKeywords){
                    self.keywords = "";
                }
                self.category_active = category_id;
                self.listLoading = true;
                self.FoxRequest(window.settings.api_url + 'utility/upload/get_list', {
                    category_id: category_id,
                    page: self.current,
                    keywords: self.keywords,
                    pagesize: self.pageSize,
                    type: 'image'
                }, function(response){
                    let data = response.data;
                    self.listLoading = false;
                    //
                    self.total = data.total;
                    self.imageList = data.list;
                });
            },
            beforeUpload(file){
                this.uploadCount ++;
            },
            dealUpload(response){
                const self = this;
                self.uploadCount --;

                if(response.error != '0'){
                    self.$message.error(response.result.message);
                }else{
                    if(self.uploadCount <= 0){
                        self.reloadImageList(self.category_active, true, true);
                    };
                }
            },
            uploadExceed(){
                const self = this;
                self.$message({
                    message: "单次上传文件个数不得超过" + self.uploadLimit + "个",
                    type: 'error',
                    duration: 1500,
                    onClose: function () {
                    }
                });
            },
            searchImageList(){
                const self = this;
                self.reloadImageList(self.category_id, true);
            },
            cancelDeleteImage(index = 0){
                this.$set(this.deleteImageVisible, index, false);
            },
            deleteImage(index = 0, imageId = '0'){
                const self = this;
                self.FoxRequest(window.settings.api_url + 'utility/upload/delete_file', {
                    id: imageId,
                    type: 'image'
                }, function(response){
                    let data = response.data;
                    if(data.error == '0'){
                        self.$message.success(data.result.message);
                        self.$set(self.deleteImageVisible, index, false);
                        self.reloadImageList(self.category_id, true);
                    }else{
                        self.$message.error(data.result.message);
                    }
                });
            },
            selectImage(index = 0){
                const self = this;
                let selectType = self.selectType;
                let imageList = self.imageList;
                let selectImageList = [];
                let selectImageIdArr = [];
                if (selectType == 'radio'){
                    // if(self.selectImageIdArr.indexOf(imageId) >= 0){
                    //     self.selectImageList = selectImageList;
                    //     self.selectImageIdArr = selectImageIdArr;
                    //     return false;
                    // }
                }else if (selectType == 'checkbox'){
                    selectImageList = self.selectImageList;
                    selectImageIdArr = self.selectImageIdArr;
                    if(selectImageIdArr.length >= self.maxSelectCount){
                        self.$message.warning("已达选择上限");
                        return false;
                    }
                }
                selectImageIdArr.push(imageList[index]['id']);
                selectImageList.push(imageList[index]);
                self.selectImageList = selectImageList;
                self.selectImageIdArr = selectImageIdArr;
            },
            cancelSelectImage(index = 0){
                //index为selectImageIdArr的键值
                const self = this;
                if (index == 'all'){
                    self.selectImageIdArr = [];
                    self.selectImageList = [];
                    return false;
                }
                let imageId = self.selectImageIdArr[index];
                //
                let selectImageListIndex = -1;
                selectImageListIndex = self.selectImageList.findIndex(item =>{
                    if(item.id == imageId){
                        return true
                    }
                });
                if(selectImageListIndex >= 0){
                    self.selectImageIdArr.splice(index, 1);
                    self.selectImageList.splice(selectImageListIndex, 1);
                }

            }
        }
    }
</script>

<style scoped>
    @import "chooseImage.css";
</style>